"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("../../elements/icons/Icon"));

var _Theme = _interopRequireDefault(require("../../themes/Theme"));

var _DesktopView = _interopRequireDefault(require("../../elements/view/DesktopView"));

var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DropdownMenu = _styledComponents["default"].div.attrs(function () {
  return {
    className: "dropdown-menu"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__DropdownMenu",
  componentId: "sc-13yaofd-0"
})(["&&&{margin-left:0;background:", ";border-radius:0 0.25rem 0.25rem 0;}"], function (props) {
  return props.theme["mlb-blue"];
});

var DropdownMenuItem = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs(function () {
  return {
    className: "dropdown-item"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__DropdownMenuItem",
  componentId: "sc-13yaofd-1"
})(["&&&{color:", ";background:", ";&:hover{color:", ";}}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["mlb-blue"];
}, function (props) {
  return props.theme["grey"];
});

var DropdownHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "btn-group dropright"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__DropdownHolder",
  componentId: "sc-13yaofd-2"
})(["&&&{&:hover > .dropdown-menu{display:block;}}"]);

var NavLink = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex justify-content-center align-items-center",
    role: "button",
    "data-toggle": "dropdown",
    "aria-haspopup": "true",
    "aria-expanded": false
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__NavLink",
  componentId: "sc-13yaofd-3"
})(["width:68px;height:50px;"]);

var MobileCategory = _styledComponents["default"].div.attrs(function () {
  return {
    className: "nav-link d-flex align-items-center"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__MobileCategory",
  componentId: "sc-13yaofd-4"
})(["&&&{color:rgb(125,124,124) !important;background:rgb(4,21,44);border-top:1px solid rgb(0,0,0);border-bottom:1px solid rgb(0,0,0);font-size:1.125rem;padding:5px 0.875rem 5px 25px;}"]);

var MobileHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "dropdown-menu",
    "aria-labelledby": "navbarDropdown"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__MobileHolder",
  componentId: "sc-13yaofd-5"
})(["&&&{ul{list-style-type:none;padding:0;}width:100%;color:", ";background:", ";display:block !important;margin:0 !important;padding:0 !important;li > a{padding-left:50px !important;}li:not(:last-child) > a{border-bottom:1px solid ", " !important;}}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["mlb-blue"];
}, function (props) {
  return props.theme["black"];
});

var MobileLink = (0, _styledComponents["default"])(_reactRouterDom.Link).attrs(function () {
  return {
    className: "nav-link"
  };
}).withConfig({
  displayName: "IconNavigationWithSubLinks__MobileLink",
  componentId: "sc-13yaofd-6"
})(["&&&{color:", ";&:hover{color:", ";}font-size:1.125rem;height:100%;padding:0.625rem 25px;border-top:1px solid ", ";}"], function (props) {
  return props.theme["white"];
}, function (props) {
  return props.theme["grey"];
}, function (props) {
  return props.theme["black"];
});

var IconNavigationWithSubLinks = function IconNavigationWithSubLinks(_ref) {
  var toggleMobileNav = _ref.toggleMobileNav,
      subLinks = _ref.subLinks,
      icon = _ref.icon,
      name = _ref.name;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_DesktopView["default"], null, _react["default"].createElement(DropdownHolder, null, _react["default"].createElement(NavLink, {
    to: ""
  }, _react["default"].createElement(_Icon["default"], {
    iconName: icon,
    styles: {
      color: _Theme["default"]["white"],
      hoverColor: _Theme["default"]["grey"]
    }
  })), _react["default"].createElement(DropdownMenu, null, subLinks.map(function (_ref2) {
    var to = _ref2.to,
        name = _ref2.name;
    return _react["default"].createElement(DropdownMenuItem, {
      key: name,
      to: to,
      onClick: function onClick() {
        if (toggleMobileNav) {
          toggleMobileNav(false);
        }
      }
    }, name);
  })))), _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(MobileCategory, null, _react["default"].createElement(_Icon["default"], {
    iconName: icon,
    styles: {
      color: _Theme["default"]["grey"],
      hoverColor: _Theme["default"]["grey"]
    },
    className: "mr-3"
  }), " ", name), _react["default"].createElement(MobileHolder, null, _react["default"].createElement("ul", null, subLinks.map(function (_ref3) {
    var to = _ref3.to,
        name = _ref3.name;
    return _react["default"].createElement("li", {
      key: name
    }, _react["default"].createElement(MobileLink, {
      to: to,
      onClick: function onClick() {
        if (toggleMobileNav) {
          toggleMobileNav(false);
        }
      }
    }, name));
  })))));
};

var DropDownShape = {
  name: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};
IconNavigationWithSubLinks.propTypes = {
  toggleMobileNav: _propTypes["default"].func.isRequired,
  name: _propTypes["default"].string.isRequired,
  icon: _propTypes["default"].string.isRequired,
  subLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)).isRequired
};
var _default = IconNavigationWithSubLinks;
exports["default"] = _default;